import React from 'react';

export const InfoIcon = () => (
  <svg
    width="12"
    height="13"
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.03838 0.0283212C1.67121 0.0283211 2.11425 0.32854 2.55728 0.568132C2.93688 0.74807 3.31699 0.988146 3.76003 1.16808C5.78541 2.18805 7.81079 3.26816 9.83566 4.34826C10.4685 4.64848 11.2911 4.94821 11.7342 5.48851C11.8605 5.66845 12.0508 5.90852 11.9874 6.20874C11.7976 6.86883 10.9115 7.10891 10.3421 7.40864C8.94959 8.12888 7.49412 8.90877 6.10157 9.62851C5.5951 9.92873 4.8359 10.4685 4.20307 10.0485C3.94983 9.92873 3.82347 9.80845 3.76003 9.62851C3.69659 9.38844 3.76003 9.0887 3.76003 8.84863L3.76003 6.92849C3.76003 6.38868 3.69659 5.96866 4.0767 5.72859C4.20307 5.66845 4.4563 5.60879 4.6461 5.66845C5.27894 5.90852 5.08914 6.98863 5.08914 7.82866L5.08914 8.48827C6.16501 7.94846 7.24088 7.40816 8.31675 6.92849C8.69635 6.74855 9.32919 6.56862 9.45606 6.08846C9.58242 5.54865 8.38019 5.12863 8.00059 4.94821L3.63367 2.60806C3.31699 2.42813 2.49436 1.82817 1.9884 2.00811C1.7986 2.06825 1.67172 2.24819 1.67172 2.36799C1.60829 2.60806 1.60829 2.96794 1.60829 3.26816L1.60829 5.18829L1.60829 8.42813C1.60829 8.90828 1.54485 9.50823 1.73465 9.80797C2.17769 10.4079 3.19012 9.32781 3.50679 10.2881C3.57023 10.5282 3.44336 10.7683 3.31699 10.8881C3.06376 11.2484 1.92445 11.7882 1.48141 11.9085C1.35505 11.9682 1.03838 12.0283 0.848579 12.0283C-0.227292 11.8484 0.0259438 10.2285 0.0259437 9.02808L0.0259432 3.08822C0.0259431 2.18805 -0.100419 0.988146 0.279179 0.448335C0.468979 0.148116 0.658778 0.148118 1.03838 0.0283212ZM4.32943 3.92825C5.27894 3.92825 5.34186 5.06849 4.45579 5.24843C3.94932 5.30857 3.56972 4.82842 3.69608 4.4084C3.82295 4.10818 4.01275 4.04804 4.32943 3.92825Z"
      fill="#2B2B2B"
    />
  </svg>
);

export const BlueInfoIcon = () => (
  <svg
    width="12"
    height="13"
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.03838 0.528321C1.67121 0.528321 2.11425 0.82854 2.55728 1.06813C2.93688 1.24807 3.31699 1.48815 3.76003 1.66808C5.78541 2.68805 7.81079 3.76816 9.83566 4.84826C10.4685 5.14848 11.2911 5.44821 11.7342 5.98851C11.8605 6.16845 12.0508 6.40852 11.9874 6.70874C11.7976 7.36883 10.9115 7.60891 10.3421 7.90864C8.94958 8.62888 7.49412 9.40877 6.10157 10.1285C5.5951 10.4287 4.8359 10.9685 4.20307 10.5485C3.94983 10.4287 3.82347 10.3085 3.76003 10.1285C3.69659 9.88844 3.76003 9.5887 3.76003 9.34863L3.76003 7.42849C3.76003 6.88868 3.69659 6.46866 4.0767 6.22859C4.20306 6.16845 4.4563 6.10879 4.6461 6.16845C5.27894 6.40852 5.08914 7.48863 5.08914 8.32866L5.08914 8.98827C6.16501 8.44846 7.24088 7.90816 8.31675 7.42849C8.69635 7.24855 9.32918 7.06862 9.45606 6.58846C9.58242 6.04865 8.38019 5.62864 8.00059 5.44821L3.63367 3.10806C3.31699 2.92813 2.49436 2.32818 1.9884 2.50811C1.7986 2.56825 1.67172 2.74819 1.67172 2.86799C1.60829 3.10806 1.60829 3.46794 1.60829 3.76816L1.60829 5.68829L1.60829 8.92813C1.60829 9.40828 1.54485 10.0082 1.73465 10.308C2.17769 10.9079 3.19012 9.82781 3.50679 10.7881C3.57023 11.0282 3.44336 11.2683 3.31699 11.3881C3.06376 11.7484 1.92445 12.2882 1.48141 12.4085C1.35505 12.4682 1.03838 12.5283 0.848579 12.5283C-0.227292 12.3484 0.0259438 10.7285 0.0259437 9.52808L0.0259432 3.58822C0.0259431 2.68805 -0.100419 1.48815 0.279179 0.948335C0.468979 0.648117 0.658778 0.648117 1.03838 0.528321ZM4.32943 4.42825C5.27894 4.42825 5.34186 5.56849 4.45579 5.74843C3.94932 5.80857 3.56972 5.32842 3.69608 4.9084C3.82295 4.60818 4.01275 4.54804 4.32943 4.42825Z"
      fill="#00AECD"
    />
  </svg>
);

export const DetailLocationIcon = () => (
  <svg
    width="12"
    height="17"
    viewBox="0 0 12 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 0.461914C2.686 0.461914 0 3.23904 0 6.66547C0.006 7.60531 0.386 8.62476 0.916 9.68143C1.826 11.4712 3.22 13.357 4.257 14.6567C4.737 15.2584 5.28 15.8902 5.63 16.2913C5.828 16.5188 6.169 16.5188 6.367 16.2913C6.717 15.8902 7.26 15.2574 7.739 14.6567C8.169 14.118 8.658 13.4832 9.15 12.7925C9.847 11.8144 10.547 10.735 11.081 9.68143C11.614 8.62476 11.994 7.60531 12 6.66547C12 3.23904 9.314 0.462948 6 0.461914ZM6 8.71161C5.448 8.71161 4.948 8.48001 4.586 8.10573C4.224 7.73145 4 7.21448 4 6.64376C4 6.07303 4.224 5.55607 4.586 5.18178C4.948 4.8075 5.448 4.5759 6 4.5759C6.552 4.5759 7.052 4.8075 7.414 5.18178C7.776 5.55607 8 6.07303 8 6.64376C8 7.21448 7.776 7.73145 7.414 8.10573C7.052 8.48001 6.552 8.71161 6 8.71161Z"
      fill="#767676"
    />
  </svg>
);

export const BriefLocationIcon = () => (
  <svg
    width="12"
    height="15"
    viewBox="0 0 12 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.5 6.52832C7.5 5.69989 6.82843 5.02832 6 5.02832C5.17157 5.02832 4.5 5.69989 4.5 6.52832C4.5 7.35675 5.17157 8.02832 6 8.02832C6.82843 8.02832 7.5 7.35675 7.5 6.52832ZM12 6.52832C12 9.40222 8.90276 12.5445 7.15886 14.0861C6.4905 14.6769 5.5095 14.6769 4.84114 14.0861C3.09724 12.5446 0 9.40222 0 6.52832C0 3.21461 2.68629 0.52832 6 0.52832C9.31371 0.52832 12 3.21461 12 6.52832ZM11 6.52832C11 3.7669 8.76142 1.52832 6 1.52832C3.23858 1.52832 1 3.7669 1 6.52832C1 7.63678 1.61464 8.92367 2.56972 10.211C3.50366 11.4699 4.65694 12.5886 5.50343 13.3368C5.79356 13.5933 6.20644 13.5933 6.49657 13.3368C7.34306 12.5886 8.49634 11.4699 9.43028 10.211C10.3854 8.92367 11 7.63678 11 6.52832Z"
      fill="#212121"
    />
  </svg>
);

export const PlayIcon = () => (
  <svg
    width="55"
    height="55"
    viewBox="0 0 55 55"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_b_1830_2965)">
      <rect
        x="0.5"
        y="0.0283203"
        width="54"
        height="54"
        rx="27"
        fill="#2E2E2E"
        style={{ mixBlendMode: 'luminosity' }}
      />
      <rect
        x="1.23524"
        y="0.763558"
        width="52.5295"
        height="52.5295"
        rx="26.2648"
        stroke="white"
        strokeOpacity="0.06"
        strokeWidth="1.47048"
      />
      <g filter="url(#filter1_dd_1830_2965)">
        <path
          d="M38.4147 25.3893C39.9389 26.2272 39.9389 28.4172 38.4147 29.2551L23.7107 37.3382C22.2407 38.1463 20.4424 37.0828 20.4424 35.4053L20.4424 19.2391C20.4424 17.5617 22.2407 16.4981 23.7107 17.3062L38.4147 25.3893Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_b_1830_2965"
        x="-58.319"
        y="-58.7907"
        width="171.638"
        height="171.638"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="29.4095" />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_1830_2965"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_1830_2965"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_dd_1830_2965"
        x="10.7949"
        y="10.3237"
        width="33.4092"
        height="34.4097"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1830_2965"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_1830_2965"
          result="effect2_dropShadow_1830_2965"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_1830_2965"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
